// extracted by mini-css-extract-plugin
module.exports = {"container":"common-auth_container__12X4J","logo":"common-auth_logo__3hCSm","copy":"common-auth_copy__4QTNq"};